module.exports = __webpack_public_path__ + "img/product_95.cd943d6.webp";